import NodeEvents from 'events';
import * as Inovx from '@shared';
import assign from 'object-assign';
import knowledgeBookConstants from './../constants/KnowledgeBookConstants';
var EventEmitter = NodeEvents.EventEmitter;
var ListHelper = Inovx.Shared.Common.ListHelper;

var CHANGE_EVENT = 'KnowledgeBook.change';
var _knowledgeBooks: IKnowledgeBook[] = [],
    _knowledgeViews: IKnowledgeView[] = [],
    _beginAdd = false,
    _beginEdit = false,
    _assignClassificationTagsModalVisible = false,
    _assignClassificationTagsKnowledgeBooks: IKnowledgeBook[] = [],
    _assignClassificationTagsSelectedTagIds: string[] = [],
    _hasChanges = false,
    _kbModalVisible = false,
    _knowledgeBookDetails: IKnowledgeBook | any = getBlankKnowledgeBook(),
    _selectedKnowledgeBook: IKnowledgeBook | any = null,
    _showKnowledgeBookDescription: boolean = false,
    _kbViewingMode: KnowledgeBookViewingMode = 'manageKV',
    _assetSets: IAssetSet[] = [],
    _kvModalVisible = false,
    _knowledgeViewDetails: IKnowledgeView = null,
    _isKBPopupPinned: boolean = false,
    _validation: IKnowledgeViewFormErrorProps = null,
    _assetSet: IAssetSet = null,
    _smartAssetSetModalVisible = false,
    _isAddingAssetSet = false,
    _hasAssetSetChanges = false,
    _facilityAssetSet: IAssetSet = null,
    _isAddingFacilityAssetSet = false,
    _hasFacilityAssetSetChanges = false,
    _favoriteKnowledgeBookIds: string[] = [];

function _initalizeValidation() {
    _setValidValidation({ Name: false, Description: false});
}
function _setValidValidation(data: IKnowledgeViewFormErrorProps) {
    _validation = data;
}
function loadAllKnowledgeBook(data: IKnowledgeBook[]) {    
    _knowledgeBooks = data;
    if (_selectedKnowledgeBook) {
        _selectedKnowledgeBook = data.find(kb => kb.ID == _selectedKnowledgeBook.ID);
    }
}

function getBlankKnowledgeBook(): IKnowledgeBook {
    return {
        ID: "",
        FacilityID: "",
        VersionToken: "",
        Description: "",
        Name: "",
        OntologyID: null,
        ClassificationTags: []
    }
}
function setAddingKnowledgeBook() {
    _beginAdd = _kbModalVisible = true;
    _beginEdit = false;
    _hasChanges = false;
    _knowledgeBookDetails = getBlankKnowledgeBook();
}
function setEditingKnowledgeBook(data: IKnowledgeBook) {
    _beginAdd = false;
    _beginEdit = _kbModalVisible  = true;
    _hasChanges = false;
    _knowledgeBookDetails = data;
}
function beginAssignClassificationTags(data: { knowledgeBooks: IKnowledgeBook[]; selectedTagIds?: string[] }) {
    _assignClassificationTagsModalVisible = true;
    _assignClassificationTagsKnowledgeBooks = data?.knowledgeBooks ?? [];
    _assignClassificationTagsSelectedTagIds = data?.selectedTagIds ?? [];
}
function updateAssignClassificationTags(data: { selectedTagIds: string[] }) {
    _assignClassificationTagsSelectedTagIds = data?.selectedTagIds ?? [];
}
function finishAssignClassificationTags() {
    _assignClassificationTagsModalVisible = false;
    _assignClassificationTagsKnowledgeBooks = [];
    _assignClassificationTagsSelectedTagIds = [];
}
function updateKnowledgeBookDetails(data: IKnowledgeBook) {
    _hasChanges = true;
    _knowledgeBookDetails = data;
}
function finishedEditingKnowledgeBook() {
    _kbModalVisible = false;
    _hasChanges = false;
}
function setKnowledgeBook(data:IKnowledgeBook) {
    _selectedKnowledgeBook = data;
}
function setEditingKnowledgeView(data: IKnowledgeView) {
    _kvModalVisible = true;
    _knowledgeViewDetails = data;
    _initalizeValidation();
}
function updateKnowledgeViewDetails(data: IKnowledgeView) {
    _hasChanges = true;
    _knowledgeViewDetails = data;
}
function finishedEditingKnowledgeView() {
    _kvModalVisible = false;
    _hasChanges = false;
}
function loadAllKnowledgeViews(data: IKnowledgeView[]) {
    _knowledgeViews = data;
}
function showKnowledgeBookDescription(status: boolean) {
    _showKnowledgeBookDescription = status;
}

function changeKnowledgeBookViewingMode(mode: KnowledgeBookViewingMode) {
    _kbViewingMode = mode;
}
function loadAllAssetSets(data: IAssetSet[]) {
    _assetSets = data;
}
function updateAssetSet(data: IAssetSet) {
    _assetSets = _assetSets.map(asset =>
        asset.ID === data.ID
            ? {
                ...asset,
                FacilityID: data.FacilityID,
                Name: data.Name,
                Type: data.Type,
                KnowledgeBookID: data.KnowledgeBookID,
                ClassificationTags: data.ClassificationTags ?? [],
                VersionToken: data.VersionToken,
                HierarchyItems: data.HierarchyItems ?? [],
                AssetTagIDs: data.AssetTagIDs ?? [],
                HierarchyItemQuery: data.HierarchyItemQuery,
                AssetTagQuery: data.AssetTagQuery,
            }
            : asset
    );
}
function updateKnowledgeViewsList(data: IKnowledgeView) {
    _knowledgeViews = _knowledgeViews.map(kv => kv.ID === data.ID ? data : kv);
}
function pinUnpinKBPopup(status: boolean) {
    _isKBPopupPinned = status;
}
function updateAllKnowledgeViews(kv: IKnowledgeView) {
    _knowledgeViews = _knowledgeViews.map(view =>
        view.ID === kv.ID
            ? { ...view, Name: kv.Name, Description: kv.Description, VersionToken: kv.VersionToken }
            : view
    );
}
function _validate() {
    let flag = true;
    if (!_knowledgeViewDetails.Name) {
        flag = false;
        _validation.Name = true;
    } else {
        _validation.Name = false;
    }
    return flag;
}

function getBlankAssetSet(): IAssetSet {
    return {
        ID: null,
        Name: "",
        VersionToken: null,
        Type: 3,
        FacilityID: _selectedKnowledgeBook?.FacilityID,
        KnowledgeBookID: _selectedKnowledgeBook?.ID,
        ClassificationTags: [],
        HierarchyItemQuery: null,
    }
}

function setAssetSetModalVisible() {
    _smartAssetSetModalVisible = true;
}

function setAddingAssetSet() {
    _isAddingAssetSet = true;
    _smartAssetSetModalVisible = true;
    _assetSet = getBlankAssetSet();
    _hasAssetSetChanges = false;
}
function setEditingAssetSet(data: IAssetSet) {
    _isAddingAssetSet = false;
    _smartAssetSetModalVisible = true;
    _assetSet = { ...data };
    _hasAssetSetChanges = false;
}
function setFinishAssetSet() {
    _isAddingAssetSet = false;
    _smartAssetSetModalVisible = false;
    _assetSet = null;
    _hasAssetSetChanges = false;
}
function updateSmartAssetSet(data: IAssetSet) {
    _assetSet = data;
    _hasAssetSetChanges = true;
}
function getBlankFacilityAssetSet(): IAssetSet {
    return {
        ID: null,
        Name: '',
        VersionToken: null,
        Type: 3,
        FacilityID: _selectedKnowledgeBook?.FacilityID,
        KnowledgeBookID: null,
        ClassificationTags: [],
        HierarchyItems: [],
        AssetTagIDs: [],
        HierarchyItemQuery: null,
        AssetTagQuery: null,
    };
}
function setAddingFacilityAssetSet() {
    _isAddingFacilityAssetSet = true;
    _facilityAssetSet = getBlankFacilityAssetSet();
    _hasFacilityAssetSetChanges = false;
}
function setEditingFacilityAssetSet(data: IAssetSet) {
    _isAddingFacilityAssetSet = false;
    _facilityAssetSet = { ...data };
    _hasFacilityAssetSetChanges = false;
}
function setFinishFacilityAssetSet() {
    _isAddingFacilityAssetSet = false;
    _facilityAssetSet = null;
    _hasFacilityAssetSetChanges = false;
}
function updateFacilityAssetSet(data: IAssetSet) {
    _facilityAssetSet = data;
    _hasFacilityAssetSetChanges = true;
}
function loadFavoriteKnowledgeBookIds(data: string[]) {
    _favoriteKnowledgeBookIds = data || [];
}

var KnowledgeBookStore: IKnowledgeBookStore = assign({}, EventEmitter.prototype, {
    getValidation() {
        return _validation;
    },

    getIsValidObject() {
        return _validate();
    },
    getSelectedKnowledgeBook: function () {
        return _selectedKnowledgeBook;
    },
    getKBModalVisible: function () {
        return _kbModalVisible;
    },
    getAssignClassificationTagsModalVisible: function () {
        return _assignClassificationTagsModalVisible;
    },
    getAssignClassificationTagsKnowledgeBooks: function () {
        return _assignClassificationTagsKnowledgeBooks;
    },
    getAssignClassificationTagsSelectedTagIds: function () {
        return _assignClassificationTagsSelectedTagIds;
    },
    getIsAdding: function () {
        return _beginAdd;
    },
    getIsEditing: function () {
        return _beginEdit;
    },
    getHasChanges: function () {
        return _hasChanges;
    },
    getKnowledgeBook: function () {
        return _knowledgeBookDetails;
    },
    getKVModalVisible: function () {
        return _kvModalVisible;
    },
    getKnowledgeViewDetail: function () {
        return _knowledgeViewDetails;
    },
    getAll: function () {
        return _knowledgeBooks;
    },
    getAllKnowledgeView: function () {
        return _knowledgeViews;
    },
    getShowKnowledgeBookDescription: function () {
        return _showKnowledgeBookDescription;
    },
    getAllAssetSet: function () {
        return _assetSets;
    },
    getKnowledgeBookViewingMode: function () {
        return _kbViewingMode;
    },
    getKBPopupPinnedStatus: function () {
        return _isKBPopupPinned;
    },
    getAssetSet: function () {
        return _assetSet;
    },
    getSmartAssetSetModalVisible: function () {
        return _smartAssetSetModalVisible;
    },
    isAddingAssetSet: function () {
        return _isAddingAssetSet;
    },
    getHasAssetSetChanges: function () {
        return _hasAssetSetChanges;
    },
    getFacilityAssetSet: function () {
        return _facilityAssetSet;
    },
    isAddingFacilityAssetSet: function () {
        return _isAddingFacilityAssetSet;
    },
    getHasFacilityAssetSetChanges: function () {
        return _hasFacilityAssetSetChanges;
    },
    getFavoriteKnowledgeBookIds: function () {
        return _favoriteKnowledgeBookIds;
    },
    isFavoriteKnowledgeBook: function (knowledgeBookID: string) {
        return _favoriteKnowledgeBookIds.indexOf(knowledgeBookID) >= 0;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback: any) {
        this.removeListener(CHANGE_EVENT, callback);
    },
});

Inovx.Shared.Flux.AppDispatcher.register(function (payload: any) {
    switch (payload.actionType) {
        case knowledgeBookConstants.KNOWLEDGE_BOOK_GET_ALL:
            loadAllKnowledgeBook(payload.data);
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_INVALID_ADD:
            break;
        case knowledgeBookConstants.KNOWLEDGE_VIEW_INVALID_ADD:
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_ADD:
            setAddingKnowledgeBook();
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_EDIT:
            setEditingKnowledgeBook(payload.data)
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_UPDATE:
            updateKnowledgeBookDetails(payload.data)
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_ASSIGN_TAGS_BEGIN:
            beginAssignClassificationTags(payload.data);
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_ASSIGN_TAGS_UPDATE:
            updateAssignClassificationTags(payload.data);
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_ASSIGN_TAGS_FINISH:
            finishAssignClassificationTags();
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_FINISH_EDIT:
            finishedEditingKnowledgeBook();
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_DETAILS:
            setKnowledgeBook(payload.data);
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_FAVORITES_GET_ALL:
            loadFavoriteKnowledgeBookIds(payload.data);
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_DELETE:
            break;
        case knowledgeBookConstants.KNOWLEDGE_VIEW_GET_ALL:
            loadAllKnowledgeViews(payload.data);
            break;
        case knowledgeBookConstants.SHOW_KNOWLEDGE_BOOK_DESCRIPTION:
            showKnowledgeBookDescription(payload.status);
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_VIEWING_MODE:
            changeKnowledgeBookViewingMode(payload.mode);
            break;
        case knowledgeBookConstants.ASSET_SETS_GET_ALL:
            loadAllAssetSets(payload.data);
            break;
        case knowledgeBookConstants.UPDATE_ASSET_SET:
            updateAssetSet(payload.data);
            break;
        case knowledgeBookConstants.KNOWLEDGE_VIEW_LIST_UPDATE:
            updateKnowledgeViewsList(payload.data);
            break;
        case knowledgeBookConstants.PIN_UNPIN_KB_POPUP:
            pinUnpinKBPopup(payload.status);
            break;
        case knowledgeBookConstants.KNOWLEDGE_VIEW_UPDATE_ALL:
            updateAllKnowledgeViews(payload.data);
            break;
        case knowledgeBookConstants.KNOWLEDGE_VIEW_BEING_EDIT:
            setEditingKnowledgeView(payload.data)
            break;
        case knowledgeBookConstants.KNOWLEDGE_VIEW_UPDATE:
            updateKnowledgeViewDetails(payload.data)
            break;
        case knowledgeBookConstants.KNOWLEDGE_VIEW_FINISH_EDIT:
            finishedEditingKnowledgeView();
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_ASSET_SET_MODAL_OPEN:
            setAssetSetModalVisible()
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_ASSET_SET_ADD:
            setAddingAssetSet();
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_ASSET_SET_EDIT:
            setEditingAssetSet(payload.data)
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_ASSET_SET_FINISH:
            setFinishAssetSet()
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_ASSET_SET_UPDATE:
            updateSmartAssetSet(payload.data)
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_FACILITY_ASSET_SET_ADD:
            setAddingFacilityAssetSet();
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_FACILITY_ASSET_SET_EDIT:
            setEditingFacilityAssetSet(payload.data)
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_FACILITY_ASSET_SET_FINISH:
            setFinishFacilityAssetSet()
            break;
        case knowledgeBookConstants.KNOWLEDGE_BOOK_FACILITY_ASSET_SET_UPDATE:
            updateFacilityAssetSet(payload.data)
            break;
        default:
            return true;
    }

    KnowledgeBookStore.emitChange();
    return true;
});

export default KnowledgeBookStore;
